import { databases, DATABASE_ID, COLLECTION_ID_TOOLS_INVENTORY } from '../config/appwrite';
import { ID, Query } from 'appwrite';

/**
 * Tools Inventory Service
 * Handles all database operations for Tools Inventory
 * Collection Name: "Tools Inventory SGM"
 * Collection ID: "ToolsInventorySGM" (Appwrite doesn't allow spaces in collection IDs)
 */

// Get all tools
export const getAllTools = async () => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID_TOOLS_INVENTORY,
      [
        Query.orderDesc('$createdAt'),
        Query.limit(1000)
      ]
    );
    return response.documents.map(formatTool);
  } catch (error) {
    console.error('Error fetching tools:', error);
    throw error;
  }
};

// Get a single tool by ID
export const getToolById = async (id) => {
  try {
    const response = await databases.getDocument(
      DATABASE_ID,
      COLLECTION_ID_TOOLS_INVENTORY,
      id
    );
    return formatTool(response);
  } catch (error) {
    console.error('Error fetching tool:', error);
    throw error;
  }
};

// Create a new tool
export const createTool = async (toolData) => {
  try {
    const documentData = {
      lot: toolData.lot || '',
      name: toolData.name || '',
      model: toolData.model || '',
      serialNumber: toolData.serialNumber || '',
      user: toolData.user || '',
      dateAssigned: toolData.dateAssigned || '',
      estimatedValue: toolData.estimatedValue || '',
      status: toolData.status || 'available'
    };

    const response = await databases.createDocument(
      DATABASE_ID,
      COLLECTION_ID_TOOLS_INVENTORY,
      ID.unique(),
      documentData
    );
    return formatTool(response);
  } catch (error) {
    console.error('Error creating tool:', error);
    throw error;
  }
};

// Update a tool
export const updateTool = async (id, toolData) => {
  try {
    const documentData = {};
    
    if (toolData.lot !== undefined) documentData.lot = toolData.lot;
    if (toolData.name !== undefined) documentData.name = toolData.name;
    if (toolData.model !== undefined) documentData.model = toolData.model;
    if (toolData.serialNumber !== undefined) documentData.serialNumber = toolData.serialNumber;
    if (toolData.user !== undefined) documentData.user = toolData.user;
    if (toolData.dateAssigned !== undefined) documentData.dateAssigned = toolData.dateAssigned;
    if (toolData.estimatedValue !== undefined) documentData.estimatedValue = toolData.estimatedValue;
    if (toolData.status !== undefined) documentData.status = toolData.status;

    const response = await databases.updateDocument(
      DATABASE_ID,
      COLLECTION_ID_TOOLS_INVENTORY,
      id,
      documentData
    );
    return formatTool(response);
  } catch (error) {
    console.error('Error updating tool:', error);
    throw error;
  }
};

// Delete a tool
export const deleteTool = async (id) => {
  try {
    await databases.deleteDocument(
      DATABASE_ID,
      COLLECTION_ID_TOOLS_INVENTORY,
      id
    );
    return { success: true };
  } catch (error) {
    console.error('Error deleting tool:', error);
    throw error;
  }
};

// Format tool from Appwrite document format to app format
const formatTool = (doc) => {
  return {
    id: doc.$id,
    lot: doc.lot || '',
    name: doc.name || '',
    model: doc.model || '',
    serialNumber: doc.serialNumber || '',
    user: doc.user || '',
    dateAssigned: doc.dateAssigned || '',
    estimatedValue: doc.estimatedValue || '',
    status: doc.status || 'available'
  };
};
